var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 4,
    viewBox: "0 0 26 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 3.33342C3.06971 3.33342 3.66667 2.73646 3.66667 2.00008C3.66667 1.2637 3.06971 0.666748 2.33333 0.666748C1.59695 0.666748 1 1.2637 1 2.00008C1 2.73646 1.59695 3.33342 2.33333 3.33342Z",
    fill: "#2E314E",
    stroke: "#2E314E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 3.33342C13.7365 3.33342 14.3334 2.73646 14.3334 2.00008C14.3334 1.2637 13.7365 0.666748 13.0001 0.666748C12.2637 0.666748 11.6667 1.2637 11.6667 2.00008C11.6667 2.73646 12.2637 3.33342 13.0001 3.33342Z",
    fill: "#2E314E",
    stroke: "#2E314E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6666 3.33342C24.403 3.33342 24.9999 2.73646 24.9999 2.00008C24.9999 1.2637 24.403 0.666748 23.6666 0.666748C22.9302 0.666748 22.3333 1.2637 22.3333 2.00008C22.3333 2.73646 22.9302 3.33342 23.6666 3.33342Z",
    fill: "#2E314E",
    stroke: "#2E314E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreInfo);
export default __webpack_public_path__ + "static/media/more_info.70b414e1cf2529cf9d9e108e86bdf985.svg";
export { ForwardRef as ReactComponent };